export const PARKING_ACTION_TYPES = {
    PARKING_LIST_REQUEST: "PARKING_LIST_REQUEST",
    PARKING_LIST_SUCCESS: "PARKING_LIST_SUCCESS",
    PARKING_LIST_FAILURE: "PARKING_LIST_FAILURE",

    PARKING_SELECT: "PARKING_SELECT",

    PARKING_UPDATE_SELECTED_LOCALLY: "PARKING_UPDATE_SELECTED_LOCALLY",

    PARKING_UPDATE_SUCCESS: "PARKING_UPDATE_SUCCESS",
    PARKING_DELETE_SUCCESS: "PARKING_DELETE_SUCCESS",

    PARKING_CHANGE_FILTER: "PARKING_CHANGE_FILTER",
    PARKING_CHANGE_OFFSET: "PARKING_CHANGE_OFFSET",
    PARKING_RESET_PAGINATION: "PARKING_RESET_PAGINATION",

    PARKING_CONFIG_SUCCESS: "PARKING_CONFIG_SUCCESS",
};
